var map = {
	"./apiParamsInitialization.js": 9,
	"./gameParameters.js": 10,
	"./httpResponse.js": 11,
	"./messageHelper.js": 12,
	"./notificationType.js": 13,
	"./notificationsName.js": 14,
	"./resources.js": 15
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;